import { ajax } from "rxjs/ajax";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { OrganizationKeyName } from "../../../model/Organization";
import { OrganizationUISettings } from "../../../model/OrganizationUISettings";
import { UISettingsSuccessResponse } from "../../../service/api-response/UISettingsSuccessResponse";
import { getAuthAndDefaultHeaders } from "../../../service/apiConsts";
import {
  AllOrganizationsListSuccessResponse,
  OrganizationListSuccessResponse,
} from "../model/OrganizationListSuccessResponse";
import { OrganizationSuccessResponse } from "../model/OrganizationSuccessResponse";

export class ApiOrganization {
  constructor(private apiEndpoint: string) {}

  getUISettings(
    token: string,
    organization: OrganizationKeyName
  ): Observable<UISettingsSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/ui-settings`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }

  setUISettings(
    token: string,
    organization: OrganizationKeyName,
    data: OrganizationUISettings
  ): Observable<any> {
    return ajax({
      method: "PUT",
      url: `${this.apiEndpoint}/organizations/${organization}/ui-settings`,
      body: data,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }

  // --- Kept below for now. Remove when redux is out of the way. ---- //

  list(
    token: string,
    organization: OrganizationKeyName
  ): Observable<OrganizationListSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}/security/organizations`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }

  listAll(token: string): Observable<AllOrganizationsListSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }

  get(
    token: string,
    organization: OrganizationKeyName
  ): Observable<OrganizationSuccessResponse> {
    return ajax({
      method: "GET",
      url: `${this.apiEndpoint}/organizations/${organization}`,
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }

  update(
    token: string,
    organization: OrganizationKeyName,
    data: any
  ): Observable<any> {
    return ajax({
      method: "PUT",
      url: `${this.apiEndpoint}/organizations/${organization}`,
      body: { ...data },
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }

  insert(token: string, data: any): Observable<any> {
    return ajax({
      method: "POST",
      url: `${this.apiEndpoint}/organizations`,
      body: { ...data },
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x: any) => x.response));
  }
}
